import React from "react";
import { Paper } from "@mui/material";
export const Card = ({ children }) => {
    return (React.createElement(Paper, { elevation: 0, sx: {
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 3,
            p: 2.5,
            backgroundColor: "background.paper",
        } }, children));
};
